export default __webpack_public_path__ + "static/media/Fishing.5bc4c206.jpg";